import { z } from 'zod';

/**
 * ライセンス追加画面のSearch Parameters
 */
export const SearchSchema = z.object({
  /** ソフトウェアID */
  softwareId: z.string().optional()
});